export const SET_PLAN_DETAILS = "SET_PLAN_DETAILS";
export const ADD_NEW_PRODUCT = "ADD_NEW_PRODUCT";
export const ADD_NEW_PRODUCT_END = "ADD_NEW_PRODUCT_END";
export const REFETCH_PRODUCT_LIST = "REFETCH_PRODUCT_LIST";
export const ADD_NEW_PRICE_PLAN = "ADD_NEW_PRICE_PLAN";
export const ADD_NEW_PLAN_END = "ADD_NEW_PLAN_END";
export const CLOSE_EDIT_PLAN = "CLOSE_EDIT_PLAN";

const initialState = {
  isLoading: true,
  addNewProduct: false,
  addPopupDisable: false,
  product_name: "",
  allProducts: [],
  allPlans: [],

  e_product_name: "",
  e_prod_details: null,
  edit_product_popup: false,
  editPopupDisable: false,
  refreshProductList: false,

  delete_product_popup: false,
  del_prod_details: null,
  deletePopupDisable: false,

  addNewPlan: false,
  addPlanBtn: false,
  plan_amount: 0,
  plan_interval: "",
  plan_product: "",
  plan_type: "",
  plan_token_limit: 0,
  plan_user_limit: 10,
  plan_product_pid: "",
  plan_tcv: "",
  plan_module_item: [],
  module_list: [],
  plan_admin_user: 0,
  plan_normal_user: 0,
  plan_description: "",
  plan_term_period: 12,

  e_plan_popup: false,
  e_plan_disable: false,
  e_plan_product: "",
  e_plan_amount: "",
  e_plan_interval_type: "",
  e_plan_interval: "",
  e_plan_module_item: [],
  e_plan_user_limit: 10,
  e_plan_gift_token: 0,
  e_plan_tcv: "",
  e_all_plan: null,
  e_plan_admin_user: 0,
  e_plan_normal_user: 0,
  e_plan_description: "",
  e_plan_term_period: 12,

  delete_plan_popup: false,
  disbale_del_popup: false,
  del_plan_details: null,
  e_plan_product_type: "",
  product_type: "normal",
  e_product_type: "",
  not_show_partner: false,
  plan_product_type: true,
  e_not_show_partner: "",
  disableDelbtn: false,
  del_prod_db_id: null,
  del_prod_type: "",
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_PLAN_DETAILS: {
      return { ...state, ...action.payload };
    }
    case ADD_NEW_PRODUCT: {
      return { ...state, addNewProduct: true, addPopupDisable: false };
    }
    case ADD_NEW_PRODUCT_END: {
      return {
        ...state,
        addNewProduct: false,
        product_name: "",
        product_type: "normal",
      };
    }
    case REFETCH_PRODUCT_LIST: {
      return { ...state, refreshProductList: true };
    }
    case ADD_NEW_PRICE_PLAN: {
      return {
        ...state,
        addNewPlan: true,
        addPlanBtn: false,
        not_show_partner: false,
      };
    }
    case ADD_NEW_PLAN_END: {
      return {
        ...state,
        addNewPlan: false,
        plan_amount: 0,
        plan_token_limit: 0,
        plan_user_limit: 10,
        plan_interval: "",
        plan_product: "",
        plan_type: "",
        plan_tcv: "",
        plan_product_pid: "",
        addPlanBtn: false,
        plan_admin_user: 0,
        plan_normal_user: 0,
        plan_description: "",
        plan_term_period: 12,
        not_show_partner: false,
        plan_product_type: true,
      };
    }
    case CLOSE_EDIT_PLAN: {
      return {
        ...state,
        e_plan_popup: false,
        e_plan_product: "",
        e_plan_amount: "",
        e_plan_interval_type: "",
        e_plan_interval: "",
        e_plan_user_limit: 10,
        e_plan_gift_token: 0,
        e_plan_tcv: "",
        e_all_plan: null,
        e_plan_admin_user: 0,
        e_plan_normal_user: 0,
        e_plan_description: "",
        e_plan_term_period: 12,
        e_not_show_partner: "",
      };
    }
    default:
      return state;
  }
};
